module.exports = new __parcel__URL__("volfova_x1.951c700d.webp").toString();